export const QUOTE_PAGE_SIZES = [10, 20, 50, 100];

export const QUOTE_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "customer_asc", label: "Customer: A–Z" },
  { value: "category_asc", label: "Category: A–Z" },
];

export function buildPageItems(current, totalPages) {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const items = new Set([1, totalPages, current, current - 1, current + 1]);
  if (current <= 3) [2, 3, 4].forEach((n) => items.add(n));
  if (current >= totalPages - 2) {
    [totalPages - 1, totalPages - 2, totalPages - 3].forEach((n) => items.add(n));
  }
  return [...items]
    .filter((n) => n >= 1 && n <= totalPages)
    .sort((a, b) => a - b)
    .reduce((acc, n, i, arr) => {
      if (i > 0 && n - arr[i - 1] > 1) acc.push("…");
      acc.push(n);
      return acc;
    }, []);
}

export function paginateItems(items, page = 1, pageSize = 10) {
  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize) || 1);
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * pageSize;
  const end = Math.min(start + pageSize, total);

  return {
    items: items.slice(start, end),
    page: safePage,
    pageSize,
    total,
    totalPages,
    showingFrom: total === 0 ? 0 : start + 1,
    showingTo: end,
  };
}

function getSearchHaystack(quote) {
  return [
    quote.quoteNumber,
    quote.name,
    quote.email,
    quote.phone,
    quote.company,
    quote.category,
    quote.quantity,
    quote.location,
    quote.message,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

function compareQuotes(a, b, sortBy) {
  switch (sortBy) {
    case "oldest":
      return new Date(a.createdAt) - new Date(b.createdAt);
    case "customer_asc":
      return String(a.name || "").localeCompare(String(b.name || ""), undefined, {
        sensitivity: "base",
      });
    case "category_asc":
      return String(a.category || "").localeCompare(String(b.category || ""), undefined, {
        sensitivity: "base",
      });
    case "newest":
    default:
      return new Date(b.createdAt) - new Date(a.createdAt);
  }
}

export function filterAndSortQuotes(quotes, filters) {
  const {
    search = "",
    status = "all",
    category = "all",
    dateFrom = "",
    dateTo = "",
    sortBy = "newest",
  } = filters;

  const query = search.trim().toLowerCase();
  const fromTime = dateFrom ? new Date(`${dateFrom}T00:00:00`).getTime() : null;
  const toTime = dateTo ? new Date(`${dateTo}T23:59:59.999`).getTime() : null;

  const filtered = (quotes || []).filter((quote) => {
    if (status !== "all" && quote.status !== status) return false;
    if (category !== "all" && quote.category !== category) return false;

    if (fromTime || toTime) {
      const placed = new Date(quote.createdAt).getTime();
      if (fromTime && placed < fromTime) return false;
      if (toTime && placed > toTime) return false;
    }

    if (query && !getSearchHaystack(quote).includes(query)) return false;
    return true;
  });

  return [...filtered].sort((a, b) => compareQuotes(a, b, sortBy));
}

export function getQuoteCategories(quotes) {
  return [...new Set((quotes || []).map((q) => q.category).filter(Boolean))].sort();
}
